
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]/refund-policy",
      function () {
        return require("private-next-pages/[channelPath]/refund-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[channelPath]/refund-policy"])
      });
    }
  